export const DEFAULT_LABEL_LINE_HEIGHT = 1.15;
